import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonButtonRowWidget, CommonMessageWidget, VOLUNTEER_MIN_MEETINGS } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { ScheduleViewerPart } from '../../../schedule/schedule-viewer/schedule-viewer.part';
import { VolunteerDialogDataService } from '../volunteer-dialog-data.service';

@Component({
	selector: 'volunteer-schedule-part',
	standalone: true,
	imports: [
		ScheduleViewerPart,
		CommonMessageWidget,
		CommonButtonRowWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './schedule.part.html',
})
export class VolunteerSchedulePart {

	public readonly dialogDataService = inject(VolunteerDialogDataService);
	public readonly dialogService = inject(DialogService);

	readonly volunteerDetails = computed(() => this.dialogDataService.volunteerDetails());


	public async addMeetings() {
		const data = this.dialogDataService.volunteerDetails();

		if (!data) return;

		const yes = await this.dialogService.confirm(`This will create a schedule with no availability for this volunteer. After adding it, please update the schedule to include at least ${VOLUNTEER_MIN_MEETINGS} slots. Do you want to continue?`, 'Yes', 'No');

		if (yes) {
			await this.dialogDataService.updateMentorSchedule(data.volunteerId);
			await this.dialogDataService.reloadData();
		}
	}

}